import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { DropzoneArea } from 'material-ui-dropzone';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@material-ui/core';
import { globalPutService, globalPostService, globalGetService } from '../../../globalServices';
import { checkApiStatus } from '../../utils_v2';
import { trackActivity } from '../../../utils/mixpanel';
import { jetStreamInstance } from '../../../shared/components';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { regexConstants } from '../../../constants/regEx';
import { Autocomplete } from '@material-ui/lab';
import { PageLoader } from '../../shared_elements';
const AddEditNonTitledAssembly = ({ addEditNonTitledAssemblies, toggleModalFn, getResponseBack, onOpenAttachments, basicDetails, aircraftId }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [nonTitledAssemblies, setNonTitledAssemblies] = useState(addEditNonTitledAssemblies.data);
    const [assetLoader, setAssetLoader] = useState(false)
    const [error, setError] = useState({});
    const [assets, setAssets] = useState([]);
    useEffect(() => {
        if (!basicDetails) {
            getAssets();
        }
    }, [])
    const onFieldChange = (key, value) => {
        setNonTitledAssemblies({ ...nonTitledAssemblies, [key]: value });
    }
    const uploadAttachments = (id, data, type) => {
        let formdata = new FormData()
        data.map(item => {
            formdata.append('files', item)
        })
        formdata.append('model_type', 3)
        formdata.append('object_id', id)
        setLoading(true)
        globalPostService(`/console/attachments/`, formdata)
            .then(response => {
                if (checkApiStatus(response)) {
                    toggleModalFn(); getResponseBack();
                    setLoading(false)
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                } else {
                    setLoading(false)
                    toggleModalFn(); getResponseBack();
                    // enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
            })
    }
    const getAssets = (query) => {
        setAssetLoader(true)
        globalGetService('console/list/?asset_type=1&dropdown=true')
            .then(response => {
                if (checkApiStatus(response)) {
                    setAssets(response?.data?.data?.asset)
                }
                setAssetLoader(false)
            })
    }
    const onAddEditNonTitledAssemblies = () => {
        let validationInputs = {};
        validationInputs = {
            description: nonTitledAssemblies?.description?.trim()?.length ? '' : 'Please enter Description',
        }
        if (nonTitledAssemblies.date_of_manufacture && !moment(nonTitledAssemblies.date_of_manufacture).isValid()) {
            validationInputs = {
                ...validationInputs,
                date_of_manufacture: 'Please enter valid Date of Manufacture',
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            if (nonTitledAssemblies.id) {
                globalPutService(`console/non-titled-assembly/${nonTitledAssemblies.id}/`, nonTitledAssemblies)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            if (nonTitledAssemblies?.files?.length) {
                                uploadAttachments(nonTitledAssemblies.id, nonTitledAssemblies.files, 'edit');
                                trackActivity('Console Management', {data:JSON.stringify(nonTitledAssemblies), page_title: 'Inventories', item_type: 'Edit', event_type: 'Edit nonTitledAssemblies Modal-Upload Attachment', event_desc: 'Upload Attachment Edited', item_id: nonTitledAssemblies?.id, item_data: nonTitledAssemblies?.files });
                            } else {
                                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                                toggleModalFn(); getResponseBack();
                                trackActivity('Console Management', {data:JSON.stringify(nonTitledAssemblies), page_title: 'Inventories', item_type: 'Edit', event_type: 'Edit nonTitledAssemblies Modal', event_desc: 'Inventories Edited', item_id: nonTitledAssemblies?.id, item_data: nonTitledAssemblies, response_msg: response?.data?.message });
                            }
                        } else {
                            setLoading(false);
                        }
                    })
            } else {
                globalPostService(`console/non-titled-assembly/`, nonTitledAssemblies)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            if (nonTitledAssemblies?.files?.length) {
                                uploadAttachments(response.data.data.id, nonTitledAssemblies.files, 'add');
                                trackActivity('Console Management', { page_title: ' Inventories', item_type: 'Add', event_type: 'Add nonTitledAssemblies Modal- Upload Attachment', event_desc: 'Upload Attachment Added', item_id: response?.data?.data?.id, item_data: nonTitledAssemblies?.files });
                            } else {
                                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                                toggleModalFn(); getResponseBack();
                                trackActivity('Console Management', { page_title: 'Inventories', item_type: 'Add', event_type: 'Add nonTitledAssemblies Modal', event_desc: 'Inventories Added', item_data: nonTitledAssemblies, response_msg: response?.data?.message });
                            }
                        } else {
                            setLoading(false);
                        }
                    })
            }
        } else {
            setError(validationInputs)
        }
    }
    return (
        <>
            <Dialog
                open={addEditNonTitledAssemblies.modal}
                onClose={() => toggleModalFn()}
                className='console-management-modal'
                maxWidth={'md'}
            >
                <DialogTitle id="scroll-dialog-title">
                    {nonTitledAssemblies.id ? addEditNonTitledAssemblies.mode === 'view' ? 'View' : 'Edit' : 'Add'} Non Titled Assembly
                </DialogTitle>
                <DialogContent dividers={true}>
                    <form>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    required
                                    name="description"
                                    label="Description"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.description}
                                    error={error.description ? true : false}
                                    helperText={error.description ? error.description : ''}
                                    onChange={(e, value) => onFieldChange('description', (e.target.value).trimStart())}
                                    onFocus={() => setError({ ...error, 'description': '' })}
                                    inputProps={{ maxLength: 255 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="serial_number"
                                    label="Serial Number"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.serial_number}
                                    onChange={(e, value) =>  onFieldChange('serial_number',(e.target.value).trimStart())}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="part_number"
                                    label="Part Number"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.part_number}
                                    onChange={(e, value) => onFieldChange('part_number', (e.target.value).trimStart())}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="owner"
                                    label={jetStreamInstance ? "Owner/SPV" : "Owner"}
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.owner}
                                    onChange={(e, value) => onFieldChange('owner', (e.target.value).trimStart())}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="location"
                                    label="Location"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.location}
                                    onChange={(e, value) => onFieldChange('location', (e.target.value).trimStart())}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            {!basicDetails ?
                                <Grid item md={4}>
                                    <Autocomplete
                                        options={assets}
                                        getOptionLabel={option => option.asset_name}
                                        id='linked_msn'
                                        disabled={addEditNonTitledAssemblies.mode === 'view' || isLoading}
                                        value={assets.find(item => item.id === nonTitledAssemblies?.linked_msn?.id) || null}
                                        onChange={(e, value) => onFieldChange('linked_msn', value)}
                                        renderInput={params => <TextField  {...params} label="Linked Asset" margin="normal" placeholder={`Select Linked Asset`} fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                    />
                                </Grid> : null}
                            <Grid item xs={12} md={4}>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        margin="normal"
                                        id="date_of_manufacture"
                                        label="Date of Manufacture"
                                        format={fieldDateFormat}
                                        fullWidth
                                        disableFuture
                                        InputLabelProps={{ shrink: true }}
                                        minDate={moment().subtract(40, 'years')}
                                        value={nonTitledAssemblies.date_of_manufacture ? nonTitledAssemblies.date_of_manufacture : null}
                                        error={error.date_of_manufacture ? true : false}
                                        helperText={error.date_of_manufacture ? error.date_of_manufacture : ''}
                                        onChange={(data, value) => { onFieldChange('date_of_manufacture', data ? moment(data).format(backendDateFormat) : null); setError({ ...error, 'date_of_manufacture': '' })}}
                                        inputVariant='outlined'
                                        disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                        onFocus={() => setError({ ...error, 'date_of_manufacture': '' })}
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="tsn"
                                    label="TSN"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.tsn || ''}
                                    onChange={(e, value) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('tsn', e.target.value) : e.preventDefault()}
                                    inputProps={{ maxLength: 12 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="csn"
                                    label="CSN"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.csn || ''}
                                    onChange={(e, value) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('csn', e.target.value) : e.preventDefault()}
                                    inputProps={{ maxLength: 12 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="tslsv"
                                    label="TSLSV"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.tslsv || ''}
                                    onChange={(e, value) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('tslsv', e.target.value) : e.preventDefault()}
                                    inputProps={{ maxLength: 12 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="cslsv"
                                    label="CSLSV"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.cslsv || ''}
                                    onChange={(e, value) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('cslsv', e.target.value) : e.preventDefault()}
                                    inputProps={{ maxLength: 12 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="llp_limiter"
                                    label="LLP Limiter"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.llp_limiter || ''}
                                    onChange={(e, value) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('llp_limiter', e.target.value) : e.preventDefault()}
                                    inputProps={{ maxLength: 12 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="tso"
                                    label="TSO"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.tso || ''}
                                    onChange={(e, value) => regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('tso', e.target.value) : e.preventDefault()}
                                    inputProps={{ maxLength: 12 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="cso"
                                    label="CSO"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.cso || ''}
                                    onChange={(e, value) => regexConstants.numberNoSpace.test(e.target.value) ? onFieldChange('cso', e.target.value) : e.preventDefault()}
                                    inputProps={{ maxLength: 12 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="status"
                                    label="Status"
                                    fullWidth
                                    margin="normal"
                                    value={nonTitledAssemblies.status}
                                    onChange={(e, value) => onFieldChange('status', e.target.value)}
                                    inputProps={{ maxLength: 50 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={12}>
                                <TextField
                                    disabled={addEditNonTitledAssemblies.mode === 'view'||isLoading}
                                    name="remarks"
                                    label="Remarks"
                                    fullWidth
                                    multiline
                                    minRows={4}
                                    margin="normal"
                                    value={nonTitledAssemblies.remarks}
                                    onChange={(e, value) => onFieldChange('remarks', e.target.value)}
                                    // inputProps={{ maxLength: 255 }}
                                    InputLabelProps={{ shrink: true }}
                                    variant='outlined'
                                />
                            </Grid>
                            <Grid item md={12}>
                                {nonTitledAssemblies.id && addEditNonTitledAssemblies?.data?.attachments?.length ?
                                    <Button onClick={onOpenAttachments} size='small' variant='outlined' color='primary'>({addEditNonTitledAssemblies.data.attachments.length})Attachment(s)</Button> : null
                                }
                                {addEditNonTitledAssemblies.mode !== 'view' ?
                                    <>
                                        <div>
                                            <DropzoneArea
                                                acceptedFiles={['.png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc, .docx']}
                                                filesLimit={10}
                                                maxFileSize={104857600}
                                                showPreviewsInDropzone={false}
                                                useChipsForPreview={true}
                                                showPreviews={true}
                                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop Documents<br /> OR <br /> Click Here<br /> </p>}
                                                dropzoneClass="drag-drop-cnt"
                                                maxWidth="sm"
                                                showAlerts={['info', 'error']}
                                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                                clearOnUnmount={true}
                                                onChange={(files) => onFieldChange('files', files)}
                                            />
                                        </div>
                                        <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Max files upload limit is 10 in single time, with supported extension ('.png, .jpg, .jpeg, .pdf, .xls, .xlsx, .doc, .docx').</span>
                                    </> : null
                                }
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button disabled={isLoading} color="primary" size='small' variant='outlined' onClick={() => { toggleModalFn(); trackActivity('Console Management', { page_title: 'Non Titled Assembly', item_type: 'Add/Edit Non Titled Assembly Modal', event_type: 'Item Clicked', event_desc: 'Clicked on Cancel Button' }) }}>Cancel</Button>
                    {addEditNonTitledAssemblies.mode !== 'view' ?
                        <Button disabled={isLoading} size='small' color="primary" variant="contained" onClick={() => { onAddEditNonTitledAssemblies(); trackActivity('Console Management', { page_title: 'Non Titled Assembly', item_type: 'Item Clicked', event_type: 'Add/Edit Non Titled Assembly Modal', event_desc: 'Clicked on Save Button' }) }}>
                            {isLoading ? <CircularProgress color="#ffffff" size={24} /> : 'Save'}
                        </Button> : null
                    }
                </DialogActions>
            </Dialog>
            {assetLoader?<PageLoader/>:null}
        </>
    )
}
export default AddEditNonTitledAssembly;